import React, { useState } from 'react';
import {
  Table, Card, Button, Space, Typography, Form, Input, Select, Tree, Upload, Radio, Cascader,
  Tag, Alert, Drawer, Descriptions, InputNumber, Divider, message, Popconfirm, Modal
} from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined, DeleteOutlined, SettingOutlined, DownloadOutlined, EditOutlined, AppstoreOutlined, CloudUploadOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;

const APP_TREE_VIEW = [
  { title: 'HomeStar', key: 'app_hs', children: [{ title: 'iOS-国内', key: 'app_hs-iOS-CN' }, { title: 'Android-国内', key: 'app_hs-Android-CN' }, { title: 'iOS-海外', key: 'app_hs-iOS-OS' }] },
  { title: '牵心Pro', key: 'app_qx', children: [{ title: 'iOS-全球', key: 'app_qx-iOS-GL' }, { title: 'Android-全球', key: 'app_qx-Android-GL' }] },
];

const CHILD_ENTS = [
  { value: 'HZ-ZL-001', label: '杭州智联科技有限公司', type: 'partner' },
  { value: 'CD-YS-002', label: '成都云视科技有限公司', type: 'child' },
  { value: 'GZ-YL-002', label: '广州云联物联网有限公司', type: 'child' },
];

const ENT_TYPE_MAP = {
  partner: { text: '合作企业', color: 'blue' },
  child: { text: '下级企业', color: 'green' },
};

const ENT_CASCADE = [
  { value: 'partner', label: '合作企业', children: CHILD_ENTS.filter(e => e.type === 'partner') },
  { value: 'child', label: '下级企业', children: CHILD_ENTS.filter(e => e.type === 'child') },
];

const ShareReassign = () => {
  const [form1] = Form.useForm();
  const [appModalVisible, setAppModalVisible] = useState(false);
  const [currentApps, setCurrentApps] = useState([]);
  const [deviceDrawerVisible, setDeviceDrawerVisible] = useState(false);
  const [deviceRecord, setDeviceRecord] = useState(null);
  // 再分润配置
  const [configVisible, setConfigVisible] = useState(false);
  const [configRecord, setConfigRecord] = useState(null);
  const [directEnts, setDirectEnts] = useState([]);
  const [editingRateKey, setEditingRateKey] = useState(null);
  const [editingRateVal, setEditingRateVal] = useState(null);
  // 指定设备添加行
  const [importEntCas, setImportEntCas] = useState(null);
  const [importFile, setImportFile] = useState(null);
  const [importRate, setImportRate] = useState(null);
  const [importCount, setImportCount] = useState(0);
  const [addDirectEnt, setAddDirectEnt] = useState(null);
  const [addDirectRate, setAddDirectRate] = useState(null);
  const [distDeviceMode, setDistDeviceMode] = useState('import');
  const [distSource, setDistSource] = useState(null);
  // 分销分润：已有配置 + 新增配置
  const [existingDistItems, setExistingDistItems] = useState([]);
  const [distItems, setDistItems] = useState([]);

  const DIST_BATCHES_MY = [
    { value: 'DS202604-001', label: 'DS202604-001（杭州智联，500台）', entName: '杭州智联科技有限公司', entId: 'HZ-ZL-001', totalCount: 500 },
    { value: 'DS202604-003', label: 'DS202604-003（广州云联，100台）', entName: '广州云联物联网有限公司', entId: 'GZ-YL-002', totalCount: 100 },
  ];
  const DIST_BATCHES_AGENT = [
    { value: 'AG202604-001', label: 'AG202604-001（鹤梦云科技，500台）', entName: '深圳星辰物联科技有限公司', entId: 'SZ-XC-001', totalCount: 500 },
    { value: 'AG202604-002', label: 'AG202604-002（鹤梦云科技，300台）', entName: '深圳星辰物联科技有限公司', entId: 'SZ-XC-001', totalCount: 300 },
  ];
  const DIST_INTERSECT = { 'DS202604-001': 45, 'DS202604-003': 30, 'AG202604-001': 22, 'AG202604-002': 0 };

  // 可再分润数据
  const redistData = [
    { key: 'r1', parentBatchNo: 'FC202604-001', parentName: '深圳星辰物联科技有限公司', parentId: 'SZ-XC-001', apps: ['app_hs-iOS-CN', 'app_hs-Android-CN', 'app_hs-iOS-OS'], productName: '智能摄像机Q1', productId: 'PROD_Q1', deviceCount: 200, rate: 5.00, directCount: 0, distCount: 0,
      devices: [
        { key: 'l1', license: 'LIC_R001', status: '已激活' },
        { key: 'l2', license: 'LIC_R002', status: '已激活' },
        { key: 'l3', license: 'LIC_R003', status: '未激活' },
      ],
      subRows: []
    },
    { key: 'r2', parentBatchNo: 'FC202604-003', parentName: '深圳星辰物联科技有限公司', parentId: 'SZ-XC-001', apps: ['app_hs-iOS-CN', 'app_qx-iOS-GL', 'app_qx-Android-GL'], productName: '户外摄像机C2', productId: 'PROD_CAM2', deviceCount: 100, rate: 3.00, directCount: 1, distCount: 2,
      devices: [{ key: 'l4', license: 'LIC_R101', status: '已激活' }],
      subRows: [
        { key: 'sr1', batchNo: 'RFC202604-001', type: '直接分润', entName: '成都云视科技有限公司', entId: 'CD-YS-002', entType: 'child', deviceCount: 100, rate: 1.50, serviceRates: [] },
        { key: 'sr2', batchNo: 'RFC202604-002', type: '分销分润', entName: '杭州智联科技有限公司', entId: 'HZ-ZL-001', entType: 'partner', deviceCount: 60, rate: 2.00, serviceRates: [{ catName: '云端存储', rate: 3.0 }], distBatchNo: 'DS202604-001', devices: [
          { key: 'sl1', license: 'LIC_R001', status: '已激活' }, { key: 'sl2', license: 'LIC_R002', status: '已激活' }, { key: 'sl3', license: 'LIC_R003', status: '未激活' },
        ] },
        { key: 'sr3', batchNo: 'RFC202604-003', type: '分销分润', entName: '广州云联物联网有限公司', entId: 'GZ-YL-002', entType: 'child', deviceCount: 30, rate: 1.50, distBatchNo: 'DS202604-003', devices: [
          { key: 'sl4', license: 'LIC_R101', status: '已激活' }, { key: 'sl5', license: 'LIC_R102', status: '未激活' },
        ] },
      ]
    },
    { key: 'r3', parentBatchNo: 'FC202604-005', parentName: '捷顺科技股份有限公司', parentId: 'A619355x', apps: ['app_qx-iOS-GL', 'app_qx-Android-GL'], productName: 'ParkingCloud传感器', productId: 'PROD_PC1', deviceCount: 150, rate: 4.00, directCount: 1, distCount: 1,
      devices: [{ key: 'l5', license: 'LIC_R201', status: '已激活' }, { key: 'l6', license: 'LIC_R202', status: '未激活' }],
      subRows: [
        { key: 'sr4', batchNo: 'RFC202604-004', type: '直接分润', entName: '广州云联物联网有限公司', entId: 'GZ-YL-002', entType: 'child', deviceCount: 150, rate: 1.00 },
        { key: 'sr5', batchNo: 'RFC202604-005', type: '分销分润', entName: '杭州智联科技有限公司', entId: 'HZ-ZL-001', entType: 'partner', deviceCount: 50, rate: 1.80, distBatchNo: '导入设备', devices: [
          { key: 'sl6', license: 'LIC_R201', status: '已激活' }, { key: 'sl7', license: 'LIC_R202', status: '未激活' },
        ] },
      ]
    },
    { key: 'r4', parentBatchNo: 'FC202604-007', parentName: '深圳拓科智能科技有限公司', parentId: 'SZ-TK-001', apps: ['app_hs-iOS-CN', 'app_hs-iOS-OS'], productName: '智能门锁S1', productId: 'PROD_S1', deviceCount: 60, rate: 6.50, directCount: 0, distCount: 0,
      devices: [{ key: 'l7', license: 'LIC_R301', status: '已激活' }],
      subRows: []
    },
  ];

  // 直接收益数据
  const directIncomeData = [
    { key: 'd1', parentBatchNo: 'FC202604-002', parentMethod: '直接分润', parentName: '深圳星辰物联科技有限公司', parentId: 'SZ-XC-001', apps: ['app_qx-iOS-GL', 'app_qx-Android-GL'], productName: 'ParkingCloud传感器', productId: 'PROD_PC1', deviceCount: 80, rate: 6.00,
      devices: [
        { key: 'l5', license: 'LIC_D001', status: '已激活' },
        { key: 'l6', license: 'LIC_D002', status: '未激活' },
      ],
      subRows: []
    },
  ];

  const [allData, setAllData] = useState(() => {
    const dist = redistData.map(d => ({ ...d, parentMethod: '分销分润' }));
    const direct = directIncomeData;
    return [dist[0], ...direct, ...dist.slice(1)];
  });


  const openConfig = (record) => {
    setConfigRecord(record);
    if (record.key === 'r1') {
      setExistingDistItems([]);
      setDistItems([{ key: `all-${Date.now()}`, source: '全部设备', batchNo: null, entName: null, entId: null, entType: null, rate: null, deviceCount: record.deviceCount }]);
      setDirectEnts([]);
    } else if (record.key === 'r2') {
      setExistingDistItems([
        { key: 'di1', source: '分销批次', batchNo: 'DS202604-001', entName: '杭州智联科技有限公司', entId: 'HZ-ZL-001', entType: 'partner', rate: 2.00, deviceCount: 45 },
        { key: 'di2', source: '分销批次', batchNo: 'DS202604-003', entName: '广州云联物联网有限公司', entId: 'GZ-YL-002', entType: 'child', rate: 1.50, deviceCount: 30 },
      ]);
      setDistItems([]);
      setDirectEnts([{ key: 'dr1', entName: '成都云视科技有限公司', entId: 'CD-YS-002', entType: 'child', rate: 1.50 }]);
    } else if (record.key === 'r3') {
      setExistingDistItems([
        { key: 'di3', source: '导入设备', batchNo: null, entName: '杭州智联科技有限公司', entId: 'HZ-ZL-001', entType: 'partner', rate: 1.80, deviceCount: 50 },
      ]);
      setDistItems([]);
      setDirectEnts([{ key: 'dr2', entName: '广州云联物联网有限公司', entId: 'GZ-YL-002', entType: 'child', rate: 1.00 }]);
    } else {
      setExistingDistItems([]);
      setDistItems([{ key: `all-${Date.now()}`, source: '全部设备', batchNo: null, entName: null, entId: null, entType: null, rate: null, deviceCount: record.deviceCount }]);
      setDirectEnts([]);
    }
    setConfigVisible(true);
    setDistDeviceMode('import'); setDistSource(null);
  };

  const handleAddEnt = (entVal, rate, list, setList, setEntVal, setRate) => {
    if (!entVal || entVal.length < 2) { message.warning('请选择企业'); return; }
    if (!rate) { message.warning('请输入分润比例'); return; }
    const entId = entVal[1];
    const ent = CHILD_ENTS.find(e => e.value === entId);
    if (!ent) return;
    if (list.some(e => e.entId === entId)) { message.warning('该企业已添加'); return; }
    setList([...list, { key: `e-${Date.now()}`, entName: ent.label, entId: ent.value, entType: ent.type, rate }]);
    setEntVal(null); setRate(null);
  };

  const entTable = (data, setData) => (
    <Table size="small" dataSource={data} rowKey="key" pagination={false}
      columns={[
        { title: '企业信息', key: 'ent', render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.entName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text></div>) },
        { title: '企业类型', key: 'entType', width: 100, render: (_, r) => { const t = ENT_TYPE_MAP[r.entType]; return t ? <Tag color={t.color}>{t.text}</Tag> : null; } },
        { title: '分润比例', dataIndex: 'rate', width: 140, align: 'right', render: (v, r) => editingRateKey === r.key ? (
          <Space size={4}>
            <InputNumber value={editingRateVal} onChange={setEditingRateVal} min={0.01} max={100} step={0.01} precision={2} addonAfter="%" size="small" style={{ width: 100 }} />
            <Button type="link" size="small" onClick={() => { setData(data.map(e => e.key === r.key ? { ...e, rate: editingRateVal } : e)); setEditingRateKey(null); }}>保存</Button>
          </Space>
        ) : (
          <span style={{ cursor: 'pointer' }} onClick={() => { setEditingRateKey(r.key); setEditingRateVal(v); }}>{v != null ? <span><Tag color="orange">{v.toFixed(2)}%</Tag> <EditOutlined style={{ fontSize: 11, color: '#1890ff' }} /></span> : <Text type="secondary">待设置</Text>}</span>
        )},
        { title: '操作', width: 60, align: 'center', render: (_, r) => <Popconfirm title="确认删除？" onConfirm={() => setData(data.filter(e => e.key !== r.key))}><Button type="link" size="small" danger icon={<DeleteOutlined />} /></Popconfirm> },
      ]}
    />
  );

  const addEntRow = (entVal, setEntVal, rate, setRate, onClick) => (
    <div style={{ display: 'flex', gap: 8, marginTop: 8, alignItems: 'center' }}>
      <Cascader value={entVal} onChange={setEntVal} placeholder="选择企业" showSearch style={{ width: 260 }} options={ENT_CASCADE} />
      <InputNumber value={rate} onChange={setRate} min={0.01} max={100} step={0.01} precision={2} addonAfter="%" placeholder="比例" style={{ width: 140 }} />
      <Button type="dashed" icon={<PlusOutlined />} onClick={onClick}>添加</Button>
    </div>
  );

  const commonCols = [
    { title: '分润批次', dataIndex: 'parentBatchNo', width: 150, render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 13 }}>{t}</Text> },
    { title: '分润上级', key: 'parent', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.parentName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.parentId}</Text></div>) },
    { title: '产品信息', key: 'product', width: 180, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.productName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.productId}</Text></div>) },
    { title: '分润应用', key: 'apps', width: 100, align: 'center', render: (_, r) => <Button type="link" size="small" icon={<AppstoreOutlined />} onClick={() => { setCurrentApps(r.apps); setAppModalVisible(true); }}>{r.apps.length} 个</Button> },
    { title: '分得比例', key: 'rate', width: 120, render: (_, r) => {
      if (r.subRows && r.subRows.length > 0) {
        const rates = [...new Set(r.subRows.map(s => s.rate))];
        return rates.length === 1 ? <Tag color="orange">{rates[0]?.toFixed(2)}%</Tag> : <Text type="secondary">{rates.length} 种比例</Text>;
      }
      return <Tag color="orange">{r.rate?.toFixed(2)}%</Tag>;
    } },
    { title: '分润设备数', dataIndex: 'deviceCount', width: 110, align: 'right', render: (v, r) => <Button type="link" style={{ padding: 0, fontWeight: 600 }} onClick={() => { setDeviceRecord(r); setDeviceDrawerVisible(true); }}>{v} 台</Button> },
  ];

  const mergedCols = [
    ...commonCols,
    { title: '上级分润方式', dataIndex: 'parentMethod', width: 110, render: (v) => <Tag color={v === '分销分润' ? 'cyan' : 'default'}>{v}</Tag> },
    { title: '操作', key: 'action', width: 160, align: 'center', render: (_, r) => r.parentMethod === '分销分润' ? (
      <Space size={0} split={<Divider type="vertical" style={{ margin: '0 4px' }} />}>
        <Button type="link" size="small" icon={<SettingOutlined />} onClick={() => openConfig(r)}>再分润</Button>
        {r.subRows && r.subRows.length > 0 && (
          <Button type="link" size="small" danger onClick={() => Modal.confirm({ title: '风险提示', okText: '确认删除', cancelText: '取消', okButtonProps: { danger: true }, content: '你正在操作删除分润配置，一旦删除此分润配置下的所有的子级分润配置都将被删除（可能会影响到你的客户分润），删除将不可恢复！', onOk: () => { setAllData(prev => prev.map(d => d.key === r.key ? { ...d, subRows: [], directCount: 0, distCount: 0 } : d)); message.success('再分润配置已删除'); } })}>删除再分润</Button>
        )}
      </Space>
    ) : null },
  ];

  const [distChildDrawerVisible, setDistChildDrawerVisible] = useState(false);
  const [distChildRecord, setDistChildRecord] = useState(null);

  const childCols = [
    { title: '分润批次', dataIndex: 'batchNo', width: 150, render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 13 }}>{t}</Text> },
    { title: '再分润类型', dataIndex: 'type', width: 100, render: (v) => <Tag color={v === '直接分润' ? 'orange' : 'cyan'}>{v}</Tag> },
    { title: '分润下级', key: 'ent', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.entName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text></div>) },
    { title: '企业类型', key: 'entType', width: 100, render: (_, r) => { const t = ENT_TYPE_MAP[r.entType]; return t ? <Tag color={t.color}>{t.text}</Tag> : null; } },
    { title: '分润设备数', dataIndex: 'deviceCount', width: 100, align: 'right', render: (v, r) => r.type === '分销分润' ? <Button type="link" style={{ padding: 0, fontWeight: 600 }} onClick={() => { setDistChildRecord(r); setDistChildDrawerVisible(true); }}>{v} 台</Button> : <Text strong>{v} 台</Text> },
    { title: '分出比例', key: 'rate', width: 140, render: (_, r) => {
      const hasSvc = r.serviceRates && r.serviceRates.length > 0;
      if (hasSvc && r.serviceRates.length <= 2) return (<div><div style={{ fontWeight: 500 }}>默认 {r.rate?.toFixed(2)}%</div>{r.serviceRates.map((s, i) => <Text key={i} type="secondary" style={{ fontSize: 11, display: 'block' }}>{s.catName} {s.rate?.toFixed(2)}%</Text>)}</div>);
      if (hasSvc && r.serviceRates.length > 2) return (<div><div style={{ fontWeight: 500 }}>默认 {r.rate?.toFixed(2)}%</div><Text type="secondary" style={{ fontSize: 11 }}>{r.serviceRates.length} 个分类已单独配置</Text></div>);
      return <Tag color="orange">{r.rate?.toFixed(2)}%</Tag>;
    } },
  ];


  const searchBar = (formInst, showChild) => (
    <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }} bodyStyle={{ padding: '12px 0' }}>
      <Form form={formInst} layout="inline" style={{ gap: 0 }}>
        <Form.Item style={{ marginRight: 8 }}>
          <Space.Compact>
            <Form.Item name="parentType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">分润上级</Option><Option value="id">上级ID</Option></Select></Form.Item>
            <Form.Item shouldUpdate={(p, c) => p.parentType !== c.parentType} noStyle>
              {({ getFieldValue }) => getFieldValue('parentType') === 'id' ? (<Form.Item name="parent" noStyle><Input placeholder="上级ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="parent" noStyle><Select placeholder="请选择分润上级" allowClear showSearch optionFilterProp="label" style={{ width: 200 }} options={redistData.map(d => ({ value: d.parentId, label: d.parentName })).filter((v, i, a) => a.findIndex(t => t.value === v.value) === i)} /></Form.Item>)}
            </Form.Item>
          </Space.Compact>
        </Form.Item>
        <Form.Item style={{ marginRight: 8 }}>
          <Space.Compact>
            <Form.Item name="prodType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">产品名称</Option><Option value="id">产品ID</Option></Select></Form.Item>
            <Form.Item shouldUpdate={(p, c) => p.prodType !== c.prodType} noStyle>
              {({ getFieldValue }) => getFieldValue('prodType') === 'id' ? (<Form.Item name="prod" noStyle><Input placeholder="产品ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="prod" noStyle><Select placeholder="请选择产品" allowClear showSearch optionFilterProp="label" style={{ width: 200 }} options={redistData.map(d => ({ value: d.productId, label: d.productName })).filter((v, i, a) => a.findIndex(t => t.value === v.value) === i)} /></Form.Item>)}
            </Form.Item>
          </Space.Compact>
        </Form.Item>
        <Form.Item name="license" style={{ marginRight: 8 }}><Input placeholder="License" allowClear style={{ width: 160 }} /></Form.Item>
        {showChild && (
          <Form.Item style={{ marginRight: 8 }}>
            <Space.Compact>
              <Form.Item name="childType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">分润下级</Option><Option value="id">下级ID</Option></Select></Form.Item>
              <Form.Item shouldUpdate={(p, c) => p.childType !== c.childType} noStyle>
                {({ getFieldValue }) => getFieldValue('childType') === 'id' ? (<Form.Item name="child" noStyle><Input placeholder="下级ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="child" noStyle><Cascader placeholder="请选择分润下级" showSearch style={{ width: 200 }} options={ENT_CASCADE} /></Form.Item>)}
              </Form.Item>
            </Space.Compact>
          </Form.Item>
        )}
        <Form.Item style={{ marginRight: 0 }}><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => formInst.resetFields()}>重置</Button></Space></Form.Item>
      </Form>
    </Card>
  );

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>分润再分配</Title></div>
      <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 8 }} message="分销分润：你可对分润上级对你的分润向下再分配。直接分润：为上级对你的一次性分润，仅你自己获得收益，不支持将其再对下分配。" />
      {searchBar(form1, true)}
      <Card bordered={false}>
        <Table columns={mergedCols} dataSource={allData} rowKey="key"
          expandable={{
            expandedRowRender: (record) => (
              <div style={{ marginLeft: 80 }}>
                <Table columns={childCols} dataSource={record.subRows} rowKey="key" size="small" pagination={false} locale={{ emptyText: '暂无再分润记录' }} />
              </div>
            ),
            rowExpandable: (record) => record.subRows && record.subRows.length > 0,
          }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>

      {/* 设备列表抽屉 */}
      <Drawer title={`分润设备 - ${deviceRecord?.productName || ''}`} width={600} onClose={() => setDeviceDrawerVisible(false)} open={deviceDrawerVisible} destroyOnClose>
        {deviceRecord && (<>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <Text strong>设备列表（{deviceRecord.deviceCount} 台）</Text>
            <Button size="small" icon={<DownloadOutlined />} onClick={() => message.success('导出成功')}>导出</Button>
          </div>
          <Table size="small" dataSource={deviceRecord.devices} rowKey="key"
            pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 台` }}
            columns={[
              { title: 'License', dataIndex: 'license', render: (t) => <Text copyable style={{ fontFamily: 'monospace' }}>{t}</Text> },
              { title: '激活状态', dataIndex: 'status', render: (v) => <Tag color={v === '已激活' ? 'green' : 'default'}>{v}</Tag> },
            ]}
          />
        </>)}
      </Drawer>

      {/* 再分润配置抽屉 */}
      <Drawer title={`再分润 - ${configRecord?.productName || ''}`} width={750} onClose={() => setConfigVisible(false)} open={configVisible} destroyOnClose

      >
        {configRecord && (<>
          <Descriptions bordered column={1} size="small" style={{ marginBottom: 16 }}>
            <Descriptions.Item label="分润批次">{configRecord.parentBatchNo}</Descriptions.Item>
            <Descriptions.Item label="分润上级">{configRecord.parentName}（{configRecord.parentId}）</Descriptions.Item>
            <Descriptions.Item label="产品信息">{configRecord.productName}（{configRecord.productId}）</Descriptions.Item>
            <Descriptions.Item label="分润设备数"><Text strong>{configRecord.deviceCount} 台</Text></Descriptions.Item>
            <Descriptions.Item label="分得比例"><Tag color="orange">{configRecord.rate.toFixed(2)}%</Tag></Descriptions.Item>
          </Descriptions>

          <div style={{ marginBottom: 24 }}>
            <Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>直接分润</Text>
            <Alert type="warning" showIcon style={{ marginBottom: 8, borderRadius: 6 }} message="你可对你获得的该批次下全部设备对下再一次性分润，不允许被分润企业再分配。" />
            {directEnts.length > 0 && entTable(directEnts, setDirectEnts)}
            {addEntRow(addDirectEnt, setAddDirectEnt, addDirectRate, setAddDirectRate, () => handleAddEnt(addDirectEnt, addDirectRate, directEnts, setDirectEnts, setAddDirectEnt, setAddDirectRate))}
          </div>
          <Divider />
          <div>
            <Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>分销分润</Text>
            <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 6 }} message="每批次仅可选择一个分润企业，支持多次导入或选择多个分销批次。" />

            {existingDistItems.length > 0 && (<div style={{ marginBottom: 16 }}>
              <Text strong style={{ display: 'block', marginBottom: 8 }}>已配置分润</Text>
              <Table size="small" dataSource={existingDistItems} rowKey="key" pagination={false}
                columns={[
                  { title: '来源', key: 'source', width: 140, render: (_, r) => r.batchNo ? <Text style={{ fontSize: 12 }}>{r.batchNo}</Text> : <Tag>导入设备</Tag> },
                  { title: '设备数', key: 'deviceCount', width: 80, align: 'right', render: (_, r) => <Text strong>{r.deviceCount != null ? `${r.deviceCount} 台` : '—'}</Text> },
                  { title: '分润企业', key: 'ent', render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.entName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text></div>) },
                  { title: '企业类型', key: 'entType', width: 100, render: (_, r) => { const t = ENT_TYPE_MAP[r.entType]; return t ? <Tag color={t.color}>{t.text}</Tag> : null; } },
                  { title: '分润比例', dataIndex: 'rate', width: 140, align: 'right', render: (v, r) => editingRateKey === r.key ? (
                    <Space size={4}><InputNumber value={editingRateVal} onChange={setEditingRateVal} min={0.01} max={100} step={0.01} precision={2} addonAfter="%" size="small" style={{ width: 120 }} /><Button type="link" size="small" onClick={() => { setExistingDistItems(existingDistItems.map(e => e.key === r.key ? { ...e, rate: editingRateVal } : e)); setEditingRateKey(null); message.success('已保存'); }}>保存</Button></Space>
                  ) : (
                    <span style={{ cursor: 'pointer' }} onClick={() => { setEditingRateKey(r.key); setEditingRateVal(v); }}>{v != null ? <span><Tag color="orange">{v.toFixed(2)}%</Tag> <EditOutlined style={{ fontSize: 11, color: '#1890ff' }} /></span> : <Text type="secondary">待设置</Text>}</span>
                  )},
                  { title: '操作', width: 60, align: 'center', render: (_, r) => <Popconfirm title="确认删除？" onConfirm={() => setExistingDistItems(existingDistItems.filter(e => e.key !== r.key))}><Button type="link" size="small" danger icon={<DeleteOutlined />} /></Popconfirm> },
                ]}
              />
              <Divider dashed style={{ margin: '12px 0' }} />
            </div>)}

            <Text strong style={{ display: 'block', marginBottom: 8 }}>新增分润配置</Text>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <Text strong>选择设备方式</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>当前可分配 <Text strong>{Math.max(0, configRecord.deviceCount - existingDistItems.reduce((s, d) => s + (d.deviceCount || 0), 0))}</Text> 台</Text>
              <Button size="small" icon={<DownloadOutlined />} onClick={() => message.success('下载成功')}>下载可分配设备</Button>
            </div>
            <Radio.Group value={distDeviceMode} onChange={(e) => {
              setDistDeviceMode(e.target.value);
              setDistSource(e.target.value === 'distribution' ? 'my' : null);
              setDistItems([]);
            }} style={{ marginBottom: 12 }}>
              <Radio.Button value="import">指定设备</Radio.Button>
              <Radio.Button value="all">全部设备</Radio.Button>
              <Radio.Button value="distribution">按分销关系</Radio.Button>
            </Radio.Group>

            {distDeviceMode === 'all' && (<div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}><Text>分配设备 <Text strong style={{ color: '#52c41a', fontSize: 16 }}>{Math.max(0, configRecord.deviceCount - existingDistItems.reduce((s, d) => s + (d.deviceCount || 0), 0) - distItems.reduce((s, d) => s + (d.deviceCount || 0), 0))}</Text> 台</Text></div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12, background: '#fafafa', padding: 12, borderRadius: 8, opacity: distItems.length > 0 ? 0.4 : 1, pointerEvents: distItems.length > 0 ? 'none' : 'auto' }}>
                <Cascader options={ENT_CASCADE} value={importEntCas} onChange={setImportEntCas} placeholder="选择企业" style={{ width: 240 }} disabled={distItems.length > 0} />
                <InputNumber value={importRate} onChange={setImportRate} min={0.01} max={100} step={0.01} precision={2} addonAfter="%" placeholder="比例" style={{ width: 140 }} disabled={distItems.length > 0} />
                <Button type="dashed" icon={<PlusOutlined />} disabled={distItems.length > 0} onClick={() => {
                  if (!importEntCas || importEntCas.length < 2) { message.warning('请选择企业'); return; }
                  if (!importRate) { message.warning('请输入分润比例'); return; }
                  const ent = CHILD_ENTS.find(e => e.value === importEntCas[1]);
                  if (distItems.some(d => d.entId === ent?.value)) { message.warning('该企业已添加'); return; }
                  const dc = Math.max(0, configRecord.deviceCount - existingDistItems.reduce((s, d) => s + (d.deviceCount || 0), 0));
                  setDistItems([...distItems, { key: `all-${Date.now()}`, source: '全部设备', entName: ent?.label, entId: ent?.value, entType: ent?.type, rate: importRate, deviceCount: dc }]);
                  setImportEntCas(null); setImportRate(null);
                  message.success('已添加');
                }}>添加</Button>
              </div>
            </div>)}

            {distDeviceMode === 'import' && (<div style={{ marginBottom: 16 }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12, background: '#fafafa', padding: 12, borderRadius: 8 }}>
                <Cascader options={ENT_CASCADE} value={importEntCas} onChange={setImportEntCas} placeholder="选择企业" style={{ width: 240 }} />
                <Upload maxCount={1} beforeUpload={(file) => { setImportFile(file); return false; }} showUploadList={false}>
                  <Button icon={<CloudUploadOutlined />}>{importFile ? importFile.name : '上传设备文件'}</Button>
                </Upload>
                <InputNumber value={importRate} onChange={setImportRate} min={0.01} max={100} step={0.01} precision={2} addonAfter="%" placeholder="比例" style={{ width: 140 }} />
                <Button type="dashed" icon={<PlusOutlined />} onClick={() => {
                  if (!importEntCas || importEntCas.length < 2) { message.warning('请选择企业'); return; }
                  if (!importFile) { message.warning('请上传设备文件'); return; }
                  if (!importRate) { message.warning('请输入分润比例'); return; }
                  const ent = CHILD_ENTS.find(e => e.value === importEntCas[1]);
                  const mockDc = [48, 36, 60][importCount % 3];
                  setImportCount(importCount + 1);
                  setDistItems([...distItems, { key: `imp-${Date.now()}`, source: '导入设备', batchNo: null, entName: ent?.label, entId: ent?.value, entType: ent?.type, rate: importRate, deviceCount: mockDc }]);
                  setImportEntCas(null); setImportFile(null); setImportRate(null);
                  message.success(`已添加，匹配 ${mockDc} 台设备`);
                }}>添加</Button>
              </div>
            </div>)}

            {distDeviceMode === 'distribution' && (<div style={{ marginBottom: 16, background: '#fafafa', padding: 16, borderRadius: 8 }}>
              <div style={{ marginBottom: 8 }}>
                <Radio.Group value={distSource} onChange={(e) => { setDistSource(e.target.value); setDistItems(distItems.filter(d => d.source !== '分销批次')); }}>
                  <Radio value="my">我的设备分销</Radio>
                  <Radio value="agent">代理设备分销</Radio>
                </Radio.Group>
              </div>
              {distSource && (
                <div>
                  <Text style={{ display: 'block', marginBottom: 4 }}>选择分销批次（可多选）：</Text>
                  <Select mode="multiple" value={distItems.filter(d => d.source === '分销批次').map(d => d.batchNo)} onChange={(vals) => {
                    const batches = distSource === 'my' ? DIST_BATCHES_MY : DIST_BATCHES_AGENT;
                    const existing = distItems.filter(d => d.source !== '分销批次');
                    const newBatchItems = vals.map(v => {
                      const prev = distItems.find(d => d.batchNo === v);
                      if (prev) return prev;
                      const batch = batches.find(b => b.value === v);
                      return { key: `dist-${v}`, source: '分销批次', batchNo: v, entName: batch?.entName || null, entId: batch?.entId || null, entType: CHILD_ENTS.find(e => e.value === batch?.entId)?.type || null, rate: null, deviceCount: DIST_INTERSECT[v] || 0 };
                    });
                    setDistItems([...existing, ...newBatchItems]);
                  }} placeholder="请选择分销批次" showSearch optionFilterProp="label" style={{ width: '100%' }}
                    options={(distSource === 'my' ? DIST_BATCHES_MY : DIST_BATCHES_AGENT)}
                  />
                </div>
              )}
            </div>)}

            {distItems.length > 0 && (<>
              <Text strong style={{ display: 'block', marginBottom: 8 }}>分润配置</Text>
              <Table size="small" dataSource={distItems} rowKey="key" pagination={false}
                rowClassName={(r) => r.deviceCount === 0 ? 'ant-table-row-error' : ''}
                columns={[
                  { title: '来源', key: 'source', width: 140, render: (_, r) => <span style={{ color: r.deviceCount === 0 ? '#ff4d4f' : undefined }}>{r.batchNo ? <Text style={{ fontSize: 12, color: r.deviceCount === 0 ? '#ff4d4f' : undefined }}>{r.batchNo}</Text> : <Tag color={r.deviceCount === 0 ? 'error' : undefined}>导入设备</Tag>}</span> },
                  { title: '设备数', key: 'deviceCount', width: 80, align: 'right', render: (_, r) => <Text style={{ color: r.deviceCount === 0 ? '#ff4d4f' : undefined }} strong>{r.deviceCount != null ? `${r.deviceCount} 台` : '—'}</Text> },
                  { title: '分润企业', key: 'ent', width: 220, render: (_, r) => r.deviceCount === 0 ? <Text type="danger">无有效设备，请移除</Text> : r.entName ? (
                    <div><Text style={{ fontWeight: 500 }}>{r.entName}</Text><br/><Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text></div>
                  ) : <Text type="secondary">未指定</Text>
                  },
                  { title: '企业类型', key: 'entType', width: 100, render: (_, r) => { if (r.deviceCount === 0) return null; const t = ENT_TYPE_MAP[r.entType]; return t ? <Tag color={t.color}>{t.text}</Tag> : null; } },
                  { title: '分润比例', dataIndex: 'rate', width: 140, align: 'right', render: (v, r) => r.deviceCount === 0 ? <Text type="danger">—</Text> : editingRateKey === r.key ? (
                    <Space size={4}>
                      <InputNumber value={editingRateVal} onChange={setEditingRateVal} min={0.01} max={100} step={0.01} precision={2} addonAfter="%" size="small" style={{ width: 100 }} />
                      <Button type="link" size="small" onClick={() => { setDistItems(distItems.map(d => d.key === r.key ? { ...d, rate: editingRateVal } : d)); setEditingRateKey(null); message.success('已保存'); }}>保存</Button>
                    </Space>
                  ) : v != null ? (
                    <span style={{ cursor: 'pointer' }} onClick={() => { setEditingRateKey(r.key); setEditingRateVal(v); }}><Tag color="orange">{v.toFixed(2)}%</Tag> <EditOutlined style={{ fontSize: 11, color: '#1890ff' }} /></span>
                  ) : (
                    <Space size={4}><InputNumber min={0.01} max={100} step={0.01} precision={2} addonAfter="%" size="small" style={{ width: 120 }} onChange={(val) => setEditingRateVal(val)} /><Button type="link" size="small" onClick={() => { if (editingRateVal) { setDistItems(distItems.map(d => d.key === r.key ? { ...d, rate: editingRateVal } : d)); message.success('已保存'); } }}>保存</Button></Space>
                  )},
                  { title: '操作', width: 60, align: 'center', render: (_, r) => <Popconfirm title="确认删除？" onConfirm={() => setDistItems(distItems.filter(d => d.key !== r.key))}><Button type="link" size="small" danger icon={<DeleteOutlined />} /></Popconfirm> },
                ]}
              />
            </>)}
          </div>
        </>)}
      </Drawer>

      {/* 分销分润设备详情抽屉 */}
      <Drawer title={`分销分润设备 - ${distChildRecord?.batchNo || ''}`} width={650} onClose={() => setDistChildDrawerVisible(false)} open={distChildDrawerVisible} destroyOnClose>
        {distChildRecord && (<>
          <Descriptions bordered column={1} size="small" style={{ marginBottom: 16 }}>
            <Descriptions.Item label="分润批次">{distChildRecord.batchNo}</Descriptions.Item>
            <Descriptions.Item label="分润下级">{distChildRecord.entName}（{distChildRecord.entId}）</Descriptions.Item>
            <Descriptions.Item label="分出比例"><Tag color="orange">{distChildRecord.rate.toFixed(2)}%</Tag></Descriptions.Item>
            <Descriptions.Item label="分润设备数"><Text strong>{distChildRecord.deviceCount} 台</Text></Descriptions.Item>
            {distChildRecord.distBatchNo && <Descriptions.Item label="关联分销批次">{distChildRecord.distBatchNo}</Descriptions.Item>}
          </Descriptions>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <Text strong>设备列表</Text>
            <Button size="small" icon={<DownloadOutlined />} onClick={() => message.success('导出成功')}>导出</Button>
          </div>
          <Table size="small" dataSource={distChildRecord.devices || []} rowKey="key"
            pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 台` }}
            columns={[
              { title: 'License', dataIndex: 'license', render: (t) => <Text copyable style={{ fontFamily: 'monospace' }}>{t}</Text> },
              { title: '激活状态', dataIndex: 'status', render: (v) => <Tag color={v === '已激活' ? 'green' : 'default'}>{v}</Tag> },
            ]}
          />
        </>)}
      </Drawer>

      {/* 分润应用弹窗 */}
      <Modal title={<Space><AppstoreOutlined style={{ color: '#1890ff' }} /><span>分润应用</span></Space>} open={appModalVisible} onCancel={() => setAppModalVisible(false)} footer={null} width={480}>
        <Tree treeData={APP_TREE_VIEW.map(app => { const m = app.children.filter(c => currentApps.includes(c.key)); if (!m.length) return null; return { ...app, title: <Text strong>{app.title}</Text>, children: m.map(c => ({ ...c, title: <Tag style={{ margin: 0 }}>{c.title}</Tag> })) }; }).filter(Boolean)} defaultExpandAll selectable={false} style={{ marginTop: 8 }} />
      </Modal>
    </div>
  );
};

export default ShareReassign;
